@if(!hasError()){
    @if (!loaded()) {
        <div class="w-full h-[60vh] animate-pulse">
            <div class="animate-pulse w-full h-full bg-dat-grey-300">
            </div>
        </div>
        }
        <section class="w-full" [class.h-[60vh]]="loaded()">
        <div class="w-full h-full iq-mc-map-mci--map" [id]="id()"
            [attr.data-testid]="id() + '-map'" [attr.data-uitype]="'map'"></div>
        </section>
    }
@else {
    <div class="w-full h-[60vh]">
        <div class="w-full h-full bg-dat-grey-100">
            <div class="flex flex-col items-center justify-center h-full">
                <span class="material-symbols-outlined text-5xl">
                    deployed_code_alert
                </span>
                <span class="text-dat-grey-800 font-caption text-[14px] mt-2">
                    Market Conditions is Current Unavailable
                </span>
                <span class="text-dat-grey-600 font-caption text-[12px] m-0">
                    Please Try Again Later
                </span>
            </div>
        </div>
    </div>
}
@if (xmaModalState) {
<iq-mc-modal-extended-market [modalData]="xmaGeographiesInPoint()" [query]="query()"
    (closed)="toggleXmaModal(false)"></iq-mc-modal-extended-market>
}